import React, { useEffect } from "react";
import "./ListingSharePage.css";

const SITE_ORIGIN = "https://chiesugu.djammadev.com";
const APP_STORE =
  "https://apps.apple.com/app/chiesugu/id6752285751";
const PLAY_STORE =
  "https://play.google.com/store/apps/details?id=com.djammadev.chiesugu";


/**
 * Page légère pour les liens partagés / Universal Links : /listing/:id
 */
function ListingSharePage({ listingId }) {
  const universalUrl = `${SITE_ORIGIN}/listing/${listingId}`;
  const customSchemeUrl = `chiesugu://listing/${listingId}`;

  useEffect(() => {
    document.title = `Annonce — Chiesugu`;

    const setMeta = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", property);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("og:url", universalUrl);
    setMeta("og:title", "Annonce sur Chiesugu");
    setMeta(
      "og:description",
      "Ouvrez cette annonce dans l'application Chiesugu — place de marché avicole.",
    );
    setMeta("og:type", "website");

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", universalUrl);
  }, [listingId, universalUrl]);

  return (
    <div className="listing-share">
      <div className="listing-share__header-bar">
        <header className="listing-share__header">
          <a href="/" className="listing-share__brand">
            Chiesugu
          </a>
          <a href="/" className="listing-share__home">
            Accueil
          </a>
        </header>
      </div>

      <main className="listing-share__main">
        <div className="listing-share__card">
          <p className="listing-share__eyebrow">Lien partagé</p>
          <h1 className="listing-share__title">Voir cette annonce dans l’app</h1>
          <p className="listing-share__text">
            Pour consulter les détails, les photos et contacter le vendeur, ouvrez l’application <strong>Chiesugu</strong>. 
            Si l’app est installée, le bouton ci-dessous peut l’ouvrir directement.
          </p>

          <div className="listing-share__actions">
            <a
              className="btn btn--primary listing-share__btn"
              href={customSchemeUrl}
            >
              Ouvrir dans l’application
            </a>
            <p className="listing-share__hint">
              Ce lien ouvre l’application <strong>Chiesugu</strong> si elle est installée.
            </p>
          </div>

          <div className="listing-share__stores">
            <span className="listing-share__stores-label">
              Pas encore l’app ?
            </span>
            <div className="listing-share__store-buttons">
              <a
                className="btn btn--secondary listing-share__store"
                href={APP_STORE}
                target="_blank"
                rel="noopener noreferrer"
              >
                App Store
              </a>
              <a
                className="btn btn--secondary listing-share__store"
                href={PLAY_STORE}
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Play
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ListingSharePage;
